module.exports = __webpack_public_path__ + "img/nyaho.8081cf40.svg";